import type { PropsWithChildren } from "react";
import { I18nProvider } from "react-aria-components";

export const I18nProviderWrapper = ({ children }: PropsWithChildren) => (
	<I18nProvider locale="pt-BR">{children}</I18nProvider>
);
